// core
import { Component, OnInit } from '@angular/core';

// campfire
import { PartnerBrandService } from '@campfire-nx/api';

@Component({
  selector: 'emergency-contact',
  templateUrl: './emergency-contact.component.html',
  styleUrls: ['./emergency-contact.component.scss']
})
export class EmergencyContactComponent implements OnInit {
  intent: any;
  companyInfo!: { [key: string]: any };
  title?: string;
  subTitle?: string;
  buttonText?: string;
  supportPhoneNumber?: string | number;
  infoList: any;

  constructor(
    private partnerBrandService: PartnerBrandService
  ) { }

  ngOnInit(): void {
    // taken from the help-contact component, maybe can be coded into the template in the future
    this.title = 'We\'re here to help';
    this.subTitle = 'If you have an emergency you can call us 24/7 and we’ll help you out.';

    this.companyInfo = this.partnerBrandService.getAttribute('companyInfo', 'partner');
    this.buttonText = this.companyInfo.SUPPORT_PHONE_INTL;
    this.supportPhoneNumber = this.companyInfo.SUPPORT_PHONE_INTL.split(' ').join('');

    this.infoList = [
      { icon: 'management-documents', text: 'Your policy number', type: 'policy' },
      { icon: 'communication-phone', text: 'Your best contact number' },
      { icon: 'management-emergencyhelp', text: 'The nature of your emergency' }
    ];
  }

  call() {
    window.location.href = `tel:${this.supportPhoneNumber}`
  }
}
